module.exports = __webpack_public_path__ + "media/images/sorry-7aad909e2edc5b6e46039c9618c98e59.jpg";